import userRoutes from "./User";

const routesMap = {
  ...userRoutes,
};
export default routesMap;
